export async function fetchStreetViewPano(
  lat: number,
  lng: number
): Promise<google.maps.StreetViewPanoramaData> {
  if (!window.google.maps) {
    throw new Error("google maps not loaded");
  }
  const locationRequest: google.maps.StreetViewLocationRequest = {
    location: { lat, lng },
    preference: google.maps.StreetViewPreference.NEAREST,
    source: google.maps.StreetViewSource.OUTDOOR,
  };
  const streetView = new window.google.maps.StreetViewService();
  const res = await streetView.getPanorama(locationRequest);
  return res.data;
}
